// extracted by mini-css-extract-plugin
module.exports = {"description":"VoucherModal_description__OIYcT","footer":"VoucherModal_footer__g1mr5"};